import { useContext } from 'react';
import ChatMessage from '../../Molecules/Message/ChatMessage';
import { EmailBoxContext } from '../../Service/Context/EmailBoxContext';
import { MessageContext } from '../../Service/Context/MessageContextV2';
import { ThemeText } from '../../Atoms/ThemeText';

const ChatMessagePreview = () => {
  const { selectedMessage } = useContext(EmailBoxContext);
  const { action } = useContext(MessageContext);

  if (!selectedMessage && !action) {
    return (
      <ThemeText align="center" size="xl" weight="lighter" mt="30%">
        Keine Nachricht ausgewählt
      </ThemeText>
    );
  }

  if (action) return null;

  return (
    <div>
      <ChatMessage phoneVersion={false} />
    </div>
  );
};

export default ChatMessagePreview;
